import { render } from "./Banner.vue?vue&type=template&id=58001ec9&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=58001ec9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58001ec9"

export default script